
const userprofile = [{"key":"userprofile.title","string":"Váš profil pre žlté stránky"},{"key":"userprofile.button.update_profile","string":"Aktualizovať profil"},{"key":"userprofile.no_profile","string":"Zatiaľ ste nepridali žiadny profil do Žltých stránok."}]

export default userprofile



// WEBPACK FOOTER //
// ./src/i18n/sk/adduserprofile/userprofile.js